import ApiClient from 'dashboard/api/ApiClient';

class ConversationResolutionSubject extends ApiClient {
  constructor() {
    super('conversation_resolution_subjects', { accountScoped: true });
  }
}

export default new ConversationResolutionSubject();
